import React from 'react';
import { ClearableError } from './shared';
import { ErrorContent } from '../ErrorContent';

interface ErrorBoundaryRudeProps {}

interface ErrorBoundaryRudeState {
  error: ClearableError;
}

/**
 * ErrorBoundaryRude shows an entire error page and should be reserved for when an
 * error is not recoverable.
 */
export class ErrorBoundaryRude extends React.Component<
  ErrorBoundaryRudeProps,
  ErrorBoundaryRudeState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      error: null
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;
    if (error) {
      return <ErrorContent msg={error?.message} />;
    }
    return children;
  }
}
